import React, { useRef } from 'react';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { ReactComponent as Arrow } from './arrow.svg';
import 'swiper/css';
import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector'));

const Partners = ({ partners }) => {
    useInspectorControl(Inspector);
    const swiperRef = useRef(null);
    const { isEditing } = useEditor();
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')');
    const slidesPerView = 'auto';

    const swiperProps = {
        slidesPerView,
        spaceBetween: isMobile ? 33 : 92,
        autoplay: { delay: 6000, disableOnInteraction: false },
        pagination: {
            clickable: true,
        },
        modules: [Autoplay, Pagination],
    };

    const swipe = (next) => {
        if (next === 1) swiperRef?.current?.swiper.slideNext(400);
        else swiperRef?.current?.swiper.slidePrev(400);
    };

    return (
        <BlockWrapper.Section className={style.block}>
            <div className={style.content}>
                <Swiper {...swiperProps} ref={swiperRef} className={style.swiper}>
                    {partners.map(
                        (el, i) =>
                            el?.image?.id && (
                                <SwiperSlide
                                    key={i}
                                    style={{ width: isMobile ? el.mobileWidth + 'px' : el.width + 'px' }}
                                >
                                    <img src={el.image.url} alt={el.image.title} />
                                </SwiperSlide>
                            ),
                    )}
                </Swiper>
                {!isMobile && !isEditing && partners.length > 3 && (
                    <div className={style.navigation}>
                        <Arrow onClick={() => swipe(-1)} />
                        <Arrow onClick={() => swipe(1)} />
                    </div>
                )}
            </div>
        </BlockWrapper.Section>
    );
};

export default defineBlock({
    Block: Partners,
    smartProps: {
        bgColor: smartProps.string.withDefault(''),
        partners: smartProps.array.withDefault([]),
    },
    setup: {
        title: 'Partenaires - slider',
        parent: ['smarftire/partners'],
    },
});
